import React, {FC, useCallback, useState} from 'react'
import {DateRangeType} from '../../../../global'
import {usePeriod, useReportData} from '../../../features'
import {DATE_RANGE} from '../../../@components'
import {PdfButtonDownload} from '../../../pages/report/components'
import {ReportContext} from '../../../@types'
import {PageHeader} from '../../../@components/widgets/PageHeader'
import {DEFAULT_DATE_RANGE} from '../../../@types/global'

const ReportProvider: FC = ({children}) => {

    const [selectedDateRange, setSelectedDateRange_] = useState<DateRangeType>(DEFAULT_DATE_RANGE)
    const period = usePeriod(selectedDateRange)

    const handleDateRangeChange = useCallback((dateRange: DateRangeType) => {
        setSelectedDateRange_(dateRange)
    }, [])
    const {data, isLoading, loading} = useReportData({period})

    return (
        <ReportContext.Provider value={data}>
            <div className="row">
                <div className="col-12">
                    <div className="mb-5">
                        <PageHeader icon={'/media/icons/duotune/animation/ani009.svg'}
                                    title={'Rapport d’activité Webforce'}
                                    description={'Consultez les détails de l’activité de votre site avec des données claires et précises. Analysez le nombre de visites, de pages vues, et de conversions. Retrouvez également des statistiques clés comme les appels, les clics, les formulaires soumis, ainsi que le Top 5 des origines géographiques des visiteurs, des pages les plus consultées, et des canaux de trafic. Ce rapport vous aide à mieux comprendre et optimiser la performance de votre site.'}
                        />
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="m-auto" style={{maxWidth: 1065}}>
                                <div className="row mb-sm-8">
                                    <div
                                        className="col-12 col-sm-5 mb-5 mb-sm-0 d-flex justify-content-end align-items-center justify-content-sm-start">
                                        <PdfButtonDownload period={period} />
                                    </div>
                                    <div className="col-12 col-sm-7 d-flex justify-content-end align-items-center">
                                        <DATE_RANGE onDateRangeChange={handleDateRangeChange}
                                                    loading={loading}
                                                    setLoading={() => {
                                                    }}
                                        />
                                    </div>
                                </div>
                                {children}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </ReportContext.Provider>
    )
}

export {ReportProvider}